import { i18nMark } from 'lingui-react';

const messages = {
  collapseAll: i18nMark('Collapse All'),
  expandAll: i18nMark('Expand All'),
  loadingNotes: i18nMark('...Loading'),
  newToOld: i18nMark('Newest to Oldest'),
  noNotesYet: i18nMark('No notes yet.'),
  oldToNew: i18nMark('Oldest to Newest'),
  oldNotesCollapsedHeader: i18nMark('({count}) Older {count, plural, one {Comment} other {Comments}}'),
  sortLabel: i18nMark('SORT:'),
  title: i18nMark('Notes {count}'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/NotesWidget/messages.js